import { Component, Renderer2 } from '@angular/core';
import * as AOS from 'aos';  import { Inject, PLATFORM_ID } from '@angular/core';

import { Title, Meta } from '@angular/platform-browser';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-challenges-manufacturing-it-industry-4-0-blog',
  templateUrl: './challenges-manufacturing-it-industry-4-0-blog.component.html',
  styleUrls: ['./challenges-manufacturing-it-industry-4-0-blog.component.css']
})
export class ChallengesManufacturingItIndustry40BlogComponent {
isBrowser:boolean=false;
baseUrl = Constants.baseUrl;
constructor(
  private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,
  private _renderer2: Renderer2,private seoService:SeoService,
  @Inject(DOCUMENT) private _document: Document,
  private metaService: Meta
) {this.isBrowser=isPlatformBrowser(this.platformId);}
  ngOnInit() {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
  {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://mitresource.com/challenges-manufacturing-it-industry-4-0/"
    },
    "headline": "Navigating the Maze: Hurdles in Embracing Manufacturing IT and Industry 4.0",
    "description": "The manufacturing sector contributes more than $8 trillion to the US economy and is a crucial part of the country's financial foundation. However, the industry's growth and long-term success rely on various factors, with the most significant being the quick adoption of new technologies.",
    "image": "https://mitresource.com/assets/images/blogs/challengesbg.png",  
    "author": {
      "@type": "Organization",
      "name": "Maganti IT Resources",
      "url": "https://mitresource.com/"
    },  
    "publisher": {
      "@type": "Organization",
      "name": "Maganti IT",
      "logo": {
        "@type": "ImageObject",
        "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
      }
    },
    "datePublished": "2023-06-05"
  }`;
   
    this._renderer2.appendChild(this._document.head, script);
  
  

if(this.isBrowser){     
  AOS.init({disable: 'mobile'});
}
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
 
  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Navigating the Maze: Hurdles in Embracing Manufacturing IT and Industry 4.0');

    this.metaService.addTags([
      { name: 'description', content: 'The manufacturing sector contributes more than $8 trillion to the US economy and is a crucial part of the country\'s financial foundation!' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Navigating the Maze: Hurdles in Embracing Manufacturing IT and Industry 4.0' },
      { property: 'og:url', content: 'https://mitresource.com/challenges-manufacturing-it-industry-4-0/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/blogs/challengesbg.png' },
      { property: 'og:description', content: 'The manufacturing sector contributes more than $8 trillion to the US economy and is a crucial part of the country\'s financial foundation.' },
    ]);
  }
}
